import { render } from "./Categorylist.vue?vue&type=template&id=4b35cb40&scoped=true"
import script from "./Categorylist.vue?vue&type=script&lang=js"
export * from "./Categorylist.vue?vue&type=script&lang=js"

import "./Categorylist.vue?vue&type=style&index=0&id=4b35cb40&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b35cb40"]])

export default __exports__